export default function PlumbingServices() {
  const services = [
    {
      icon: 'ri-tools-line',
      title: 'Emergency Plumbing',
      description: '24/7 emergency services for burst pipes, water leaks, and urgent plumbing issues throughout El Paso.',
      features: ['Burst Pipe Repair', 'Water Leak Detection', 'Drain Cleaning', 'Emergency Shutoff']
    },
    {
      icon: 'ri-water-flash-line',
      title: 'Water Heater Services',
      description: 'Installation, repair, and maintenance of traditional and tankless water heaters for optimal performance.',
      features: ['Tankless Installation', 'Water Heater Repair', 'Maintenance Plans', 'Energy Efficiency']
    },
    {
      icon: 'ri-home-gear-line',
      title: 'Residential Plumbing',
      description: 'Complete plumbing solutions for homes including fixture installation, pipe repair, and system upgrades.',
      features: ['Fixture Installation', 'Pipe Replacement', 'Bathroom Remodels', 'Kitchen Plumbing']
    },
    {
      icon: 'ri-building-line',
      title: 'Commercial Plumbing',
      description: 'Professional plumbing services for businesses, restaurants, and commercial properties in El Paso.',
      features: ['Commercial Repairs', 'Grease Trap Service', 'Backflow Prevention', 'Code Compliance']
    },
    {
      icon: 'ri-drop-line',
      title: 'Drain & Sewer',
      description: 'Expert drain cleaning and sewer line services using advanced camera inspection and hydro-jetting.',
      features: ['Video Inspection', 'Hydro-Jetting', 'Sewer Line Repair', 'Root Removal']
    },
    {
      icon: 'ri-recycle-line',
      title: 'Repiping Services',
      description: 'Complete repiping solutions for older homes with outdated or corroded plumbing systems.',
      features: ['Whole House Repiping', 'PEX Installation', 'Copper Piping', 'Minimal Disruption']
    }
  ];

  return (
    <section className="py-20 px-6 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Comprehensive Plumbing Services
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            From emergency repairs to complete system installations, El Paso plumbers provide expert solutions for all your plumbing needs.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-xl p-8 border-2 border-gray-200 hover:border-blue-500 hover:shadow-xl transition-all">
              <div className="w-16 h-16 flex items-center justify-center bg-blue-100 rounded-lg mb-6">
                <i className={`${service.icon} text-3xl text-blue-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
              <p className="text-gray-600 mb-4 leading-relaxed">{service.description}</p>
              <ul className="space-y-2">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center gap-2 text-sm text-gray-700">
                    <i className="ri-check-line text-blue-600"></i>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
